import client from '@/api/helper/client'
import type { HttpResponse } from '@/api/helper/http.define'
import type { AxiosResponse } from 'axios'

export const collectLog = function (params: { account_id: string; project: string; [key: string]: any }) {
  return client.post<AxiosResponse<HttpResponse<any>>>('/courtclerk/api/v1/in/logs/collect', params)
}
